// Page PdfTemplate

import React from 'react'
import async from 'async'

import app from '../../../app.jsx'
import PdfTemplateForm from '../../pdftemplate/pdftemplate_form/pdftemplate_form.jsx'
import util from '../../../lib/util.jsx'
import BaseSettings from '../../page/base_setting/base_setting.jsx'

class PagePdfTemplate extends BaseSettings {
  constructor (props) {
    super(props, 'setting-pdftemplate', 'setting-user', 'setting-pdftemplate')

    this.data = {
      teamPdfTemplates: [],
      termsAndCondition: ''
    }

    this.state = {
      isLoading: true,
      dataDate: new Date()
    }

    this._references = {
      pageHeader: React.createRef()
    }

    this._bUnMounted = false
  }

  componentWillUnmount () {
    this._bUnMounted = true
  }

  renderContent () {
    return (
      <PdfTemplateForm
        onSubmit={this._onSubmit.bind(this)}
        isQuickbookConnected={app.isQuickbookConnected()}
        teamPdfTemplates={this.data.teamPdfTemplates}
        fontFamilies={this.data.fontFamilies}
        onError={this._onError.bind(this)}
        uploadError={this._onUploadTemplateError.bind(this)}
        onPdfPreview={this._onPdfPreview.bind(this)}
        termsAndCondition={this.data.termsAndCondition}
      />
    )
  }

  _onUploadTemplateError (message) {
    if (message) {
      this.showError('common.form.uploadError')
    }
  }

  componentDidMount () {
    this._getData()
  }

  getContentClassname () {
    return 'alt'
  }

  /* Event Handlers */
  _onChangePage (pageIdent) {
    app.changePage(pageIdent)
  }

  _onSubmit (templateObj, templateId, attachment, fileDeleted) {
    this._savePdfTemplate(
      templateObj,
      templateId,
      attachment,
      fileDeleted,
      err => {
        if (err) {
          this._onError()
        } else {
          this._reloadData()

          if (this._references.pageHeader.current) {
            this._references.pageHeader.current.showSuccess(
              'setting.pdfTemplate.msgSuccessTitle',
              'setting.pdfTemplate.msgSuccessContent'
            )
          }
        }
      }
    )
  }

  _onPdfPreview (templateObj, _templateId, attachment, existFileObj) {
    const teamId = app.getTeamId()
    const userId = app.loggedInId

    let tempFileFirstPath = ''
    if (
      attachment &&
      attachment.templateFile &&
      existFileObj.bTemplateFileUploaded
    ) {
      tempFileFirstPath = `teams/${teamId}/pdftemplates/${attachment.templateFile.fileName}`
    } else if (
      attachment &&
      attachment.templateFile &&
      !existFileObj.bTemplateFileUploaded
    ) {
      tempFileFirstPath = attachment.templateFile.fileName
    }

    let tempFileSecondPath = ''
    if (
      attachment &&
      attachment.templateFileSecondary &&
      existFileObj.bTemplateFileSecondaryUploaded
    ) {
      tempFileSecondPath = `teams/${teamId}/pdftemplates/${attachment.templateFileSecondary.fileName}`
    } else if (
      attachment &&
      attachment.templateFileSecondary &&
      !existFileObj.bTemplateFileSecondaryUploaded
    ) {
      tempFileSecondPath = attachment.templateFileSecondary.fileName
    }

    const pdfTemplate = {
      showAddress: templateObj.showAddress,
      showLogo: templateObj.showLogo,
      showFooter: templateObj.showFooter,
      showSign: templateObj.showSign,
      showPageNumbers: templateObj.showPageNumbers,
      fontFamily: templateObj.fontFamily,
      tempFileFirstPath: tempFileFirstPath,
      tempFileSecondPath: tempFileSecondPath,
      headerHeightPercentage: templateObj.headerHeightPercentage,
      footerHeightPercentage: templateObj.footerHeightPercentage
    }

    const objUrl = util.getUrlFromObject(pdfTemplate)

    if (templateObj) {
      window.open(
        encodeURI(
          `/pdftemplate/preview/${teamId}/${userId}/${templateObj.ident}${
            objUrl ? '?' + objUrl : ''
          }`
        )
      )
    }
  }

  _savePdfTemplate (
    templateObj,
    templateId,
    attachment,
    fileDeleted,
    callback
  ) {
    const params = { query: { $client: {} } }

    if (attachment) {
      params.query.$client.attachment = attachment
    }

    if (fileDeleted) {
      params.query.$client.attachmentDelete = fileDeleted
    }

    if (templateId) {
      app
        .service('/api/team/pdftemplate')
        .patch(templateId, templateObj, params)
        .then(_updateRes => {
          callback(null)
        })
        .catch(updateErr => {
          app.debug('PagePdfTemplate: _onSubmit updateErr', updateErr)
          callback(updateErr)
        })
    } else {
      app
        .service('/api/team/pdftemplate')
        .create(templateObj, params)
        .then(_result => {
          callback(null)
        })
        .catch(err => {
          app.debug('PagePdfTemplate: _onSubmit err', err)
          callback(err)
        })
    }
  }

  _reloadData () {
    this._getData()
  }

  _onError () {
    if (this._references.pageHeader.current) {
      this._references.pageHeader.current.showError(
        'setting.pdfTemplate.msgErrorTitle',
        'setting.pdfTemplate.msgErrorInfo'
      )
    }
  }

  /* Private Functions */
  _getData () {
    async.series(
      [
        done => {
          this._getPageData(done)
        },
        done => {
          this._getDataPdfTemplates(done)
        }
      ],
      (err, _res) => {
        this._onDataReceived(err)
      }
    )
  }

  _getDataPdfTemplates (callback) {
    app.debug('PagePdfTemplate: _getDataPdfTemplates [start]')
    const featureToggles = app.getFeatureToggles()

    app
      .service('/api/team/pdftemplate')
      .find()
      .then(result => {
        if (
          featureToggles.FEATURE_USE_NEW_PDF_SERVICE === 'true' &&
          result.fontFamilies
        ) {
          this.data.fontFamilies = result.fontFamilies
        }
        if (result && result.data && result.data.length > 0) {
          this.data.teamPdfTemplates = result.data
        }
        callback(null)
      })
      .catch(callback)
  }

  _onDataReceived (err) {
    if (this._bUnMounted) return

    if (err) {
      app.debug('PagePdfTemplate: _onDataReceived Error', err)
    } else {
      app.debug('PagePdfTemplate: _onDataReceived [done]')
    }
    this.setState({ isLoading: !!err, dataDate: new Date() })
  }
}

export default PagePdfTemplate
